import PropTypes from 'prop-types';

import Flex from 'shopper/components/Flex';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import OfferDropdownMobile from './OfferDropdownMobile';

import STORES from 'constants/store';

const OfferMainTopMobile = ({
  offerCoupon,
  offerClicks,
  storeDomain,
  offerId,
  offerInstructions,
  offerPrice,
  offerPriceType,
  offerStatusName,
  userId,
}) => {
  return (
    <Flex
      display={['flex', null, 'none']}
      justifyContent="space-between"
      px={4}
      py={2}
    >
      <Flex flexDirection="column" justifyContent="center">
        <Text size="size2">{STORES.DESCRIPTION_OFFER_STORE}</Text>
        <Text size="size2" bold>
          {storeDomain}
        </Text>
      </Flex>
      <Flex alignItems="center">
        <Flex>
          <Icon name="visibility" size="size3" mr={2} />
          <Text size="size2">{offerClicks.toLocaleString('pt-BR')}</Text>
        </Flex>
        <OfferDropdownMobile
          offerId={offerId}
          offerStatusName={offerStatusName}
          offerInstructions={offerInstructions}
          offerPrice={offerPrice}
          offerPriceType={offerPriceType}
          offerCoupon={offerCoupon}
          userId={userId}
        />
      </Flex>
    </Flex>
  );
};

OfferMainTopMobile.defaultProps = {
  offerCoupon: null,
  offerClicks: 0,
  offerInstructions: null,
};

OfferMainTopMobile.propTypes = {
  offerCoupon: PropTypes.string,
  offerClicks: PropTypes.number,
  offerId: PropTypes.number.isRequired,
  offerInstructions: PropTypes.string,
  offerPrice: PropTypes.number.isRequired,
  offerPriceType: PropTypes.string.isRequired,
  offerStatusName: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
};

export default OfferMainTopMobile;
